<template>
  <div
    v-if="whitelabel.omDesign"
    class="omk-radio-select-container"
    :class="{ 'flex-column': flexColumn }"
  >
    <omk-radio
      v-for="item in items"
      :key="item.value"
      :group-name="group"
      :label="item.text"
      :value="item.value"
      :checked="value === item.value"
      @change="handleChange"
      :sublabel="item.subLabel"
      :custom-validation-message="errors[0]"
    >
    </omk-radio>
  </div>

  <v-radio-group
    v-else
    row
    @change="handleChange"
    :value="value"
    :error-messages="errors"
  >
    <v-radio
      v-for="item in items"
      :key="item.value"
      :label="item.text"
      :value="item.value"
      :class="className"
      :active-class="activeClass"
    />
  </v-radio-group>
</template>

<script>
  export default {
    name: 'RadioSelect',
    inheritAttrs: false,
    props: {
      value: {
        type: [String, Number, Boolean],
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'text',
      },
      prefix: {
        type: String,
        default: '',
      },
      suffix: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: true,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
      autocomplete: {
        type: String,
        default: 'off',
      },
      hint: {
        type: String,
        default: '',
      },
      persistentHint: {
        type: Boolean,
        default: false,
      },
      customClass: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        required: false,
      },
      errors: {
        type: Array,
        default: () => [],
      },
      isDateField: {
        type: Boolean,
        default: false,
      },
      remainderOfEstateMargin: {
        type: Boolean,
        default: false,
      },
      max: {
        type: Number,
        default: null,
      },
      items: {
        type: Array,
        default: () => [],
      },
      group: {
        required: true,
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'primary',
      },
      activeClass: {
        type: String,
        default: '',
      },
      className: {
        type: String,
        default: '',
      },
      flexColumn: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleInput(event) {
        const value = event.target ? event.target.value : event;
        this.$emit('input', value);
      },
      handleClick(event) {
        this.$emit('click', event);
      },
      handleChange(event) {
        let value = event.target ? event.target.value : event;

        if (value === 'true') {
          value = true;
        } else if (value === 'on') {
          value = false;
        }

        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .omk-radio-select-container {
    display: flex;
    gap: 12px;
    margin: 24px 0;

    &.flex-column {
      display: flex;
      flex-direction: column;
    }

    &:not(.flex-column) {
      width: auto; /* Allow container to shrink to content */
      justify-content: flex-start; /* Align items to the left */
    }
  }

  .world-wide-choice {
    width: 100%;
    border-radius: 6px;
    font-weight: bold;
    margin-right: 0;
    margin-bottom: 5px;
    padding: 15px;
  }

  /* Target OMK web components from scoped CSS */
  ::v-deep omk-radio {
    display: flex;
    align-items: flex-start;
    width: auto; /* Allow radio to size to content */
    flex-shrink: 0; /* Prevent shrinking */
  }
  ::v-deep omk-radio-button {
    flex: 0 0 24px;
    min-width: 24px;
    width: 24px;
  }
  ::v-deep omk-label {
    flex: 0 1 auto; /* Allow label to shrink if needed */
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
</style>
